import { useMutation, useQueryClient } from '@tanstack/react-query'
import { deleteVideo } from '@/services/youtube.service'
import { YOUTUBE_VIDEOS_QUERY_KEY } from '@/hooks/useAddYouTubeVideo'

/**
 * Mutation hook for deleting a saved YouTube video from a project.
 *
 * On success, invalidates the YOUTUBE_VIDEOS_QUERY_KEY query so the grouped-by-channel
 * list in YouTubeVideoSection refetches automatically and the deleted card disappears.
 * Uses the internal Scribelate video UUID (video.id), not the YouTube video ID.
 */
export const useDeleteYouTubeVideo = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ videoId }: { videoId: string; projectId: number }) => deleteVideo(videoId),
    onSuccess: (_data, { projectId }) => {
      queryClient.invalidateQueries({ queryKey: [YOUTUBE_VIDEOS_QUERY_KEY, projectId] })
      // Invalidate the projects list so ProjectList shows updated video counts
      queryClient.invalidateQueries({ queryKey: ['projects'] })
    },
  })
}
